export const SCHEMA = {
  ORGANIZATION: 'https://schema.org/Organization',
  POSTAL_ADDRESS: 'https://schema.org/PostalAddress',
  LIST_ITEM: 'https://schema.org/ListItem',
  BREADCRUMBS_LIST: 'https://schema.org/BreadcrumbList',
  WP_HEADER: 'https://schema.org/WPHeader',
  SITE_NAVIGATION_ELEMENT: 'https://schema.org/SiteNavigationElement',
  WP_FOOTER: 'https://schema.org/WPFooter',
  BLOG: 'https://schema.org/Blog',
  BLOG_POSTING: 'https://schema.org/BlogPosting',
  ARTICLE: 'https://schema.org/Article',
  WEB_PAGE: 'https://schema.org/WebPage',
  ITEM_LIST: 'https://schema.org/ItemList',
  PRODUCT: 'https://schema.org/Product',
  OFFER: 'https://schema.org/Offer',
  IN_STOCK: 'https://schema.org/InStock',
};
